export const allParams = ["gender", "family", "diameter", "size", "material", "alt_material", "bezel", "dial", "indexes", "bracelet", "new", "function", "submaterial", "global_category", "alt_bezel", "gemset", "category"]

export function getCurrentUrl() {
	return new URL(process.browser ? global.location.href : "https://www.rolex.com")
}

export function addParam(name, value, params) {
	params.append(name, value)
}

export function removeParam(name, value, params) {
	const listValues = params.getAll(name)

	params.delete(name)

	listValues.forEach(element => {
		if (element !== value) params.append(name, element)
	})
}

export function getAllParams() {
	let params = {}

	const currentUrl = getCurrentUrl()

	currentUrl.searchParams.forEach((value, key) => {
		if (params[key]) {
			params[key].push(value)
		} else {
			params[key] = [value]
		}
	})

	return params
}

export function getParamsPerFacet(facet) {
	let params = []

	const currentUrl = getCurrentUrl()

	if (currentUrl) params = currentUrl.searchParams.getAll(facet)

	return params
}
